export const SUBSCRIPTION_TIERS = {
  free: {
    name: 'Free',
    monthlyPrice: 0,
    uploadsPerMonth: 1,        // 1 lifetime, not monthly
    additionalUploadPrice: null,
    tutorQueries: 3,           // 3 lifetime
    diagnosticDimensions: 4,
    features: ['quick-profile', 'one-upload', 'learning-interface'],
  },
  learner: {
    name: 'Learner',
    monthlyPrice: 9.99,
    uploadsPerMonth: 1,
    additionalUploadPrice: 2.99,
    tutorQueries: 20,
    diagnosticDimensions: 8,
    features: ['full-profile', 'tutor', 'learning-paths', 'exports-basic'],
  },
  pro: {
    name: 'Pro',
    monthlyPrice: 27.99,
    uploadsPerMonth: 5,
    additionalUploadPrice: 1.99,
    tutorQueries: -1, // unlimited
    diagnosticDimensions: 8,
    features: ['full-profile', 'tutor', 'learning-paths', 'analytics', 'exports-all', 'priority', 'recalibration'],
  },
  teams: {
    name: 'Teams',
    monthlyPrice: 19.99, // per seat
    uploadsPerMonth: 5,   // per user
    additionalUploadPrice: 1.49,
    tutorQueries: -1,
    diagnosticDimensions: 8,
    features: ['full-profile', 'tutor', 'learning-paths', 'analytics', 'exports-all', 'priority', 'team-reports', 'recalibration'],
  },
} as const;

export const COACH_ADDON = {
  monthlyPrice: 7.99,
  features: [
    'biweekly-cadence',
    'unlimited-adhoc-recalibration',
    'opus-priority-routing',
    'counterfactual-simulator',
    'auto-pilot-recalibration',
  ],
  monthlyRecalibrationSoftCap: 60,
} as const;

export type SubscriptionTier = keyof typeof SUBSCRIPTION_TIERS;

export const TIER_LIMITS = {
  free: {
    uploads: { included: 1, period: 'lifetime' as const, maxPages: 10, additionalPrice: null },
    tutorQueries: { included: 3, period: 'lifetime' as const },
    diagnosticDimensions: 4,
    learningInterface: 'full' as const,
  },
  learner: {
    uploads: { included: 1, period: 'month' as const, maxPages: null, additionalPrice: 2.99 },
    tutorQueries: { included: 20, period: 'month' as const },
    diagnosticDimensions: 8,
    learningInterface: 'full' as const,
  },
  pro: {
    uploads: { included: 5, period: 'month' as const, maxPages: null, additionalPrice: 1.99 },
    tutorQueries: { included: Infinity, period: 'month' as const },
    diagnosticDimensions: 8,
    learningInterface: 'full_analytics' as const,
  },
  teams: {
    uploads: { included: 5, period: 'month' as const, maxPages: null, additionalPrice: 1.49 },
    tutorQueries: { included: Infinity, period: 'month' as const },
    diagnosticDimensions: 8,
    learningInterface: 'full_team' as const,
  },
} as const;
